import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useSession } from '../API/Context/SessionContext';
import { FRONTEND_ROUTES } from '../ConfigFiles/Routes/frontend_routes';

const ProtectedRoute:React.FC = () => {
  const { isAuthenticated, isLoading } = useSession();

  if (isLoading) {
    return (
        <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: "100vh" }}>
            <Spinner animation="border" variant="primary" role="status">
                <span className="visually-hidden">Loading Session...</span>
            </Spinner>
        </div>
    ); 
  }

  if (!isAuthenticated) {
    return <Navigate to={FRONTEND_ROUTES.auth} replace />; 
  }
  return <Outlet />; 
};

export default ProtectedRoute;